import { format } from 'date-fns'

export function formatDate(d) {
  return format(new Date(d), "yyyy-MM-dd hh:mm")
}